import { useEffect } from 'react';
import { observer } from 'mobx-react-lite';
import SVGPureIcon from '@ui/svg-icon';
import copyShareStore, {SHARE_STATUS_MAP, SHARE_INFO_MAP} from './store';
import chatStoreManager from '@/store/chat/manager';


/** 复制链接 */
export const CopyLink = observer(() => {
  return (
    <div
      className="w-138px h-94px px-8px py-16px box-border hover:bg-black hover:bg-opacity-3 rounded-12px cursor-pointer text-center"
      onClick={copyShareStore.copyLink}
    >
      <div className="flex justify-center items-center size-36px mb-8px mx-auto bg-[#006AFF] rounded-full">
        <SVGPureIcon
          name="icon_link"
          className="size-16px"
          iconClass={'text-white'}
        />
      </div>
      <p className="leading-22px">复制链接</p>
    </div>
  );
});


/** 分享到案例广场 */
export const ShareToCase = observer(() => {
  const { icon, text } = SHARE_INFO_MAP[copyShareStore.shareStatus];
  
  return (
    <div
      className="w-138px h-94px px-8px py-16px box-border hover:bg-black hover:bg-opacity-3 rounded-12px cursor-pointer text-center"
      onClick={copyShareStore.shareToSquare}
    >
      <div className={[
        'flex justify-center items-center size-36px mb-8px mx-auto rounded-full',
        {
          'bg-black': [SHARE_STATUS_MAP.NOT_SHARE, SHARE_STATUS_MAP.SHARE_DISABLE].includes(copyShareStore.shareStatus), // 未分享、 分享禁用
          'bg-black bg-opacity-10': copyShareStore.shareStatus === SHARE_STATUS_MAP.SHARE_CHECKING, // 分享审核中
          'bg-[#FEF5F6]': copyShareStore.shareStatus === SHARE_STATUS_MAP.SHARE_OPEN, // 分享开放中
        }
      ]}>
        <SVGPureIcon
          name={icon}
          className="size-22px"
          iconClass={copyShareStore.shareStatus === SHARE_STATUS_MAP.SHARE_OPEN ? 'text-[#FF3B30]' : 'text-white'}
        />
      </div>
      <p className="leading-22px">{text}</p>
    </div>
  );
});

const AgentConversationMenu = props => {
  useEffect(() => {
    if(
      !chatStoreManager.current.chatId
      || !chatStoreManager.current.mcpStore.isMcpAgent
    ){
      return;
    }

    copyShareStore.getShareStatus();
  }, [chatStoreManager.current.mcpStore.isMcpAgent, chatStoreManager.current.chatId]);

  return (
    <div className="group-hover:block hidden absolute right-0 top-[100%]  z-2 pt-8px">
      <div
        className="w-320px h-166px px-16px bg-white rounded-16px"
        style={{
          boxShadow: '0px 2px 8px 0px rgba(0, 0, 0, 0.12)',
        }}
      >
        <div className="flex justify-between items-center h-48px font-bold-600 text-14px leading-48px border-b border-[rgba(0,0,0,0.06)]">
          分享对话
          <SVGPureIcon
            name="icon_close"
            className="size-28px cursor-pointer hover:opacity-80"
          />
        </div>

        <div className="flex justify-center gap-8px mt-8px text-14px">
          {/* 复制链接 */}
          <CopyLink />

          {/* 分享到案例广场 */}
          <ShareToCase />
        </div>
      </div>
    </div>
  );
};

export default observer(AgentConversationMenu);
